// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"203":"efd94787","238":"efd94787","458":"4a796802","553":"351042fa","678":"efd94787"}[chunkId] + ".chunk.css";
};